
import React from 'react';
import { Input } from "@/components/ui/input";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";

interface RepaymentFiltersProps {
  filterPeriod: string;
  filterStatus: string;
  searchQuery: string;
  onPeriodChange: (value: string) => void;
  onStatusChange: (value: string) => void;
  onSearchChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
}

export const RepaymentFilters: React.FC<RepaymentFiltersProps> = ({
  filterPeriod,
  filterStatus,
  searchQuery,
  onPeriodChange,
  onStatusChange,
  onSearchChange
}) => {
  return (
    <div className="flex flex-col gap-2">
      <div className="flex gap-2">
        <Select value={filterPeriod} onValueChange={onPeriodChange}>
          <SelectTrigger className="w-[140px]">
            <SelectValue placeholder="Filter period" />
          </SelectTrigger>
          <SelectContent>
            <SelectItem value="all">All Periods</SelectItem>
            <SelectItem value="upcoming">Upcoming</SelectItem>
            <SelectItem value="thisMonth">This Month</SelectItem>
            <SelectItem value="thisQuarter">This Quarter</SelectItem>
          </SelectContent>
        </Select>
        <Select value={filterStatus} onValueChange={onStatusChange}>
          <SelectTrigger className="w-[130px]">
            <SelectValue placeholder="Filter status" />
          </SelectTrigger>
          <SelectContent>
            <SelectItem value="all">All Status</SelectItem>
            <SelectItem value="Due">Due</SelectItem>
            <SelectItem value="Paid">Paid</SelectItem>
            <SelectItem value="Overdue">Overdue</SelectItem>
          </SelectContent>
        </Select>
      </div>
      <div className="mt-2">
        <Input 
          placeholder="Search by borrowing name..." 
          value={searchQuery} 
          onChange={onSearchChange}
          className="max-w-sm"
        />
      </div>
    </div>
  );
};
